"use strict";
/**
 * Helpers for dealing with types that must be strings, as in GET query strings.
 * When GET endpoints want to accept booleans or numbers, they can use the
 * typebox types here and the associated functions to convert the received
 * values from a string to the desired type.
 *
 * Example:
 *
 * import * as QsTypes from "./util/QsTypes";
 * const bodyT = TypeObject({
 *   userId: Type.String({format: "uuid")),
 *   includeDeactivated: Type.Optional(QsTypes.booleanT),
 * });
 *
 * async function handler(input: PlaccRouteInput<typeof bodyT>) {
 *   const realIncludeDeactivated = QsTypes.toBoolean(input.body.includeDeactivated);
 *   // ...
 * }
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberT = exports.booleanT = void 0;
exports.toBoolean = toBoolean;
exports.toNumber = toNumber;
const typebox_1 = require("@sinclair/typebox");
/**
 * Typebox type for strings that can be auto-converted to a boolean by this
 * utility.
 *
 * A GET API endpoint could use this as the field for a boolean to be liberal
 * in what it accepts.
 */
exports.booleanT = typebox_1.Type.Union([
    typebox_1.Type.Literal("1"),
    typebox_1.Type.Literal("0"),
    typebox_1.Type.Literal("true"),
    typebox_1.Type.Literal("True"),
    typebox_1.Type.Literal("false"),
    typebox_1.Type.Literal("False"),
    typebox_1.Type.Literal("t"),
    typebox_1.Type.Literal("f"),
    typebox_1.Type.Literal("T"),
    typebox_1.Type.Literal("F"),
    typebox_1.Type.Literal("yes"),
    typebox_1.Type.Literal("no"),
    typebox_1.Type.Literal("Yes"),
    typebox_1.Type.Literal("No"),
    typebox_1.Type.Literal("y"),
    typebox_1.Type.Literal("n"),
    typebox_1.Type.Literal("Y"),
    typebox_1.Type.Literal("N"),
    typebox_1.Type.Literal("on"),
    typebox_1.Type.Literal("off"),
    typebox_1.Type.Literal("On"),
    typebox_1.Type.Literal("Off"),
    typebox_1.Type.Literal(""),
]);
/**
 * Typebox type for strings that can be auto-converted to a number by this
 * utility.
 */
exports.numberT = typebox_1.Type.String({ format: "double" });
function toBoolean(val) {
    if (val === undefined)
        return undefined;
    if (typeof val === "boolean")
        return val;
    const lcVal = val.toLowerCase();
    return (lcVal === "1" ||
        lcVal === "true" ||
        lcVal === "t" ||
        lcVal === "yes" ||
        lcVal === "y" ||
        lcVal === "on");
}
function toNumber(val) {
    if (val === undefined)
        return undefined;
    if (typeof val === "number")
        return val;
    return parseFloat(val);
}
//# sourceMappingURL=QsTypes.js.map